import { createListenerMiddleware } from '@reduxjs/toolkit';
import { monitoring } from 'common/services';
import type { RootState } from 'store';

import { nattersApi } from './nattersApi';
import type { PostAvailabilityPayload } from './types';

export const nattersApiMonitoringListener = createListenerMiddleware<RootState>();

nattersApiMonitoringListener.startListening({
  matcher: nattersApi.endpoints.createNatter.matchFulfilled,
  effect: ({ payload }) => {
    monitoring.trackAction('open_natter.created', {
      id: payload.id,
      num_slots: payload.availableSlots.length,
      has_video: payload.videos.length > 0,
      has_description: !!payload.description,
    });
  },
});

nattersApiMonitoringListener.startListening({
  matcher: nattersApi.endpoints.postAvailability.matchFulfilled,
  effect: ({ meta, payload }) => {
    const { id } = meta.arg.originalArgs as PostAvailabilityPayload;

    monitoring.trackAction('open_natter.availability_submitted', {
      id,
      num_slots: payload.slots.length,
    });
  },
});
